var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo6(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 141,
    viewBox: "0 0 103 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.199 47.3936C102.248 46.8975 103.198 35.0773 98.1081 29.9211C94.0657 25.7962 62.6177 8.45969 49.2881 1.19244C46.9227 -0.101462 42.7155 -0.568337 40.0399 0.949224L5.95505 20.9611C2.29065 23.043 1.6993 26.6718 1.61205 30.2811L0.002814 99.247C-0.094128 104.024 2.31973 108.402 6.30405 110.678L54.8914 138.58C56.7236 139.64 58.7497 140.165 60.7564 140.156C62.7437 140.156 64.7213 139.64 66.5244 138.619L80.9785 131.663L81.88 62.4048C81.9091 60.1284 83.1694 58.0853 85.1858 57.0444L102.151 47.8801L102.189 47.3839L102.199 47.3936Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo6);
export default __webpack_public_path__ + "static/media/logo-6.1648486125bbc8f3cc14728d80b5251b.svg";
export { ForwardRef as ReactComponent };